import CommunicationProgramScreen from './CommunicationProgramScreen.js';

export default CommunicationProgramScreen;
